export default __webpack_public_path__ + "static/media/pushNotificationInfo.85fe89de.gif";